import { render, staticRenderFns } from "./EntityFolderEmpty.vue?vue&type=template&id=77033a00&"
import script from "./EntityFolderEmpty.vue?vue&type=script&lang=ts&"
export * from "./EntityFolderEmpty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports